
import { defineComponent } from 'vue';
import SvgIcon from './SvgIcon.vue';
import BaseButton from './BaseButton.vue';

export default defineComponent({
  name: 'BaseAlert',

  components: {
    SvgIcon,
    BaseButton
  },

  props: {
    variant: {
      type: String,
      default: 'info',
      validator(value: string) {
        return ['error', 'success', 'warning', 'info'].includes(value);
      }
    },
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    },
    dismissible: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    hasActionSlot(): boolean {
      return !!this.$slots.actions;
    },
    hasBodyContent(): boolean {
      return !!this.$slots.default;
    },
    showActions(): boolean {
      return this.isDismissible || this.hasActionSlot;
    },
    isVisible(): boolean {
      return this.value;
    },
    isDismissible(): boolean {
      return this.dismissible;
    },
    animationName(): string {
      // Disable animations in Cypress for percy
      if (typeof window !== 'undefined' && window.Cypress) {
        return '';
      }
      return 'fade';
    },
    iconName(): string {
      const iconMap: { [key: string]: string } = {
        error: 'error',
        success: 'tick',
        warning: 'warning',
        info: 'info-bubble'
      };
      return this.icon ? this.icon : iconMap[this.variant];
    }
  },

  created() {
    if (this.icon) {
      console.warn(
        'Warning: The icon prop is under review and might be removed in the future. Please use variant instead.'
      );
    }
  },

  methods: {
    handleClose() {
      this.$emit('input', false);
    }
  }
});
